import { render } from "./AppJumbotron.vue?vue&type=template&id=866135f0&scoped=true"
import script from "./AppJumbotron.vue?vue&type=script&lang=js"
export * from "./AppJumbotron.vue?vue&type=script&lang=js"

import "./AppJumbotron.vue?vue&type=style&index=0&id=866135f0&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-866135f0"]])

export default __exports__